import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useChatContext } from 'stream-chat-react';
import { RootState } from 'src/store';
import { initializeClientAction } from 'src/store/messages/actions';

export const useChatClient = () => {
  const dispatch = useDispatch();
  const { client: chatClient } = useChatContext();
  const clientInitialized = useSelector(
    (state: RootState) => state.messages.clientInitialized,
  );
  const userLoaded = useSelector((state: RootState) => state.user.loaded);
  const usersLoaded = useSelector(
    (state: RootState) => state.users.loadedUsers,
  );

  useEffect(() => {
    // To initialize the chat client, the webapp uses the
    // current user getstreamId. This property lives in the
    // current user object which is looked up from the users
    // state. For this reason, the chat client init action
    // should only be dispatched after the user and users
    // states have been loaded.
    if (!userLoaded || !usersLoaded) return;
    dispatch(initializeClientAction(chatClient));
  }, [chatClient, userLoaded, usersLoaded]);

  return clientInitialized ? chatClient : null;
};
